window.RamelowInfiniteScroll = window.RamelowInfiniteScroll || {
  observer: null,
  mutationObserver: null,
  isFetching: false,
  hasMorePages: true,
  nextPageUrl: null,
  currentStateKey: null,
  mutationTimer: null,

  selectors: {
    grid: '.product-grid',
    loader: '.infinite-scroll-loader',
    nextLink: '.pagination__next'
  },

  getStateKey() {
    const nextLink = document.querySelector(this.selectors.nextLink);
    const nextHref = nextLink ? nextLink.getAttribute('href') : '';

    return [
      window.location.pathname,
      window.location.search,
      nextHref
    ].join('|');
  },

  destroyObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },

  init() {
    const grid = document.querySelector(this.selectors.grid);
    const loader = document.querySelector(this.selectors.loader);
    const nextLink = document.querySelector(this.selectors.nextLink);

    if (!grid || !loader) return;

    this.destroyObserver();

    this.currentStateKey = this.getStateKey();
    this.isFetching = false;
    this.hasMorePages = true;

    if (!nextLink || !nextLink.getAttribute('href')) {
      loader.style.display = 'none';
      return;
    }

    this.nextPageUrl = new URL(nextLink.getAttribute('href'), window.location.href).href;

    loader.style.display = 'block';
    loader.textContent = 'Lade weitere...';

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadNextPage();
        }
      });
    }, {
      rootMargin: '300px 0px'
    });

    this.observer.observe(loader);
  },

  getExistingIds(grid) {
    const ids = new Set();

    grid.querySelectorAll('[data-product-id], product-block').forEach((el) => {
      const id =
        el.getAttribute('data-product-id') ||
        el.dataset.productId ||
        el.id ||
        '';

      if (id) ids.add(id);
    });

    return ids;
  },

  async loadNextPage() {
    if (this.isFetching || !this.hasMorePages || !this.nextPageUrl) return;

    const grid = document.querySelector(this.selectors.grid);
    const loader = document.querySelector(this.selectors.loader);

    if (!grid || !loader) return;

    this.isFetching = true;
    loader.textContent = 'Lade...';

    try {
      const response = await fetch(this.nextPageUrl, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const fetchedGrid = doc.querySelector(this.selectors.grid);

      if (!fetchedGrid) {
        this.hasMorePages = false;
        this.nextPageUrl = null;
        loader.style.display = 'none';
        this.destroyObserver();
        return;
      }

      const fetchedItems = fetchedGrid.querySelectorAll('[data-product-id], product-block');
      const existingIds = this.getExistingIds(grid);
      const fragment = document.createDocumentFragment();

      let appended = 0;

      fetchedItems.forEach((item) => {
        const id =
          item.getAttribute('data-product-id') ||
          item.dataset.productId ||
          item.id ||
          '';

        if (id && existingIds.has(id)) return;

        fragment.appendChild(document.importNode(item, true));
        appended++;
      });

      if (appended > 0) {
        grid.appendChild(fragment);

        document.dispatchEvent(new CustomEvent('ramelow:infinite-scroll:loaded'));
      }

      const newNextLink = doc.querySelector(this.selectors.nextLink);

      if (newNextLink && newNextLink.getAttribute('href')) {
        this.nextPageUrl = new URL(newNextLink.getAttribute('href'), window.location.href).href;
        this.currentStateKey = this.getStateKey();
        loader.textContent = 'Lade weitere...';
      } else {
        this.hasMorePages = false;
        this.nextPageUrl = null;
        loader.style.display = 'none';
        this.destroyObserver();
      }
    } catch (error) {
      console.error('[Ramelow Infinite Scroll]', error);
      loader.textContent = 'Fehler beim Laden. Bitte Seite neu laden.';
    } finally {
      this.isFetching = false;
    }
  },

  watchAjaxChanges() {
    if (this.mutationObserver) return;

    const target = document.querySelector('main') || document.body;

    if (!target) return;

    this.mutationObserver = new MutationObserver(() => {
      if (this.isFetching) return;

      clearTimeout(this.mutationTimer);

      this.mutationTimer = setTimeout(() => {
        const newStateKey = this.getStateKey();

        if (newStateKey !== this.currentStateKey) {
          this.init();
        }
      }, 300);
    });

    this.mutationObserver.observe(target, {
      childList: true,
      subtree: true
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.RamelowInfiniteScroll.init();
  window.RamelowInfiniteScroll.watchAjaxChanges();
});

document.addEventListener('shopify:section:load', () => {
  window.RamelowInfiniteScroll.init();
});

document.addEventListener('theme:collection:updated', () => {
  window.RamelowInfiniteScroll.init();
});

document.addEventListener('theme:search:updated', () => {
  window.RamelowInfiniteScroll.init();
});